@let isAuthorized = isAuthorized$ | async;
@let companyConfiguration = companyConfiguration$ | async;

<div class="auth-page-wrap">

    <div class="auth-page-body auth-page-body--bottom">

        <div class="auth-panel" @fadeIn>

            <logo class="auth-header-logo">
            </logo>

            <div class="auth-body">

                <div class="auth-body-top">

                    @if (invitation?.isWorkspaceAddition) {

                    <div class="auth-body-title rpc-title-font">
                        {{ 'REGISTRATION.WORKSPACE_TITLE' | translate }}
                    </div>

                    <div class="auth-body-text">
                        {{ 'REGISTRATION.WORKSPACE_WELCOME' | translate }}
                        {{companyConfiguration.productNameAlias}}.
                    </div>

                    <div class="auth-body-text">
                        {{ 'REGISTRATION.WORKSPACE_INVITE' | translate }}:
                    </div>

                    } @else {

                    <div class="auth-body-title rpc-title-font">
                        {{ 'REGISTRATION.TITLE' | translate }}
                    </div>

                    <div class="auth-body-text">
                        {{ 'REGISTRATION.WELCOME' | translate }} {{companyConfiguration.productNameAlias}}.
                    </div>

                    <div class="auth-body-text">
                        {{ 'REGISTRATION.INVITE' | translate }}:
                    </div>

                    }

                </div>

                @if (isAuthorized) {

                <div class="auth-logout-description">

                    <rpc-icon class="auth-logout-description-icon" [iconName]="'info-circle-fill'">
                    </rpc-icon>

                    <div class="auth-logout-description-text">

                        <div class="auth-logout-description-paragraph">
                            {{ 'REGISTRATION.LOGOUT_WARNING_1' | translate }}
                        </div>

                        <div class="auth-logout-description-paragraph">
                            {{ 'REGISTRATION.LOGOUT_WARNING_2' | translate }}
                        </div>

                    </div>

                </div>

                <div class="auth-form-footer">

                    <rpc-button [color]="'accent'" [isMainButton]="true" [appearanceType]="'flat'"
                        [text]="'REGISTRATION.BUTTONS.CONTINUE'" (clicked)="continue()">
                    </rpc-button>

                    <rpc-button class="auth-form-footer-back" [isMainButton]="true" [appearanceType]="'flat'"
                        [text]="'REGISTRATION.BUTTONS.CANCEL'" (clicked)="cancel()">
                    </rpc-button>

                </div>

                } @else {

                <agent-short-info class="auth-agent-info"
                    [agent]="invitation?.invitatingAgent != null ? invitation?.invitatingAgent : invitation?.agent">
                </agent-short-info>

                <registration-form class="auth-form-wrap" [isWorkspaceAddition]="invitation?.isWorkspaceAddition"
                    [customerData]="invitation?.customer" (formSubmited)="onRegistration($event)">
                </registration-form>

                }

            </div>

        </div>

    </div>

</div>

<additional-footer class="global-additional-footer">
</additional-footer>